import React from 'react';
import { createUseStyles } from 'react-jss';
import TransitionText from '../common/TransitionText';
import SecondaryCopy from './SecondaryCopy';
import SecondaryHeadline from './SecondaryHeadline';

const useStyles = createUseStyles(
    {
        wrap: {
            display: 'flex',
            alignItems: 'center',
            minHeight: '100%',
        },

        frame: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            marginBottom: 100,
            overflow: 'hidden',
            width: '100%',
        },
    },
    { name: 'SecondaryText' }
);

export default function SecondaryText({ hotspot, state }) {
    const classes = useStyles();

    return (
        <div className={classes.wrap}>
            <div className={classes.frame}>
                <SecondaryHeadline
                    title={hotspot.content.title}
                ></SecondaryHeadline>
                <SecondaryCopy>{hotspot.content.copy}</SecondaryCopy>
            </div>
        </div>
    );
}
